import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthService as AuthAsUserService } from "src/portal/user-api/services/auth.service";
import { UsersService } from "src/portal/user-api/services/users.service";
import { register as registerSwiper } from 'swiper/element/bundle';
import { IStore } from "../storage/store";
import { AuthService } from "./core/services/auth.service";
import { ScriptService } from "./core/services/script.service";
import { ThemeService } from "./core/services/theme.service";


registerSwiper();
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

    title = "ui-client";

    constructor(
        private store: Store<IStore>,
        private authService: AuthService,
        private location: Location,
        private router: Router,
        private authAsUserService: AuthAsUserService,
        private usersService: UsersService,
        private scriptService:ScriptService,
        private themeService: ThemeService
    ) {
      this.scriptService.load('categories');
    }

    get preferredName(): string {
        return this.authService.getUserClaims()?.preferred_username;
    }

    get isEntryPage(): boolean {
      return this.location.path() === '' || this.location.path().startsWith('/validate/email');
  }

    get isUserAs(): boolean {
      return this.authService.isUserAs
    }

    get authAsName(): string {
      return this.authService?.userAsInfo?.name;
    }

    ngOnInit(): void {
      if (this.themeService.isRhetorikTheme()) {
        this.themeService.activateTheme('rhetorik-theme');
      }
      localStorage.setItem("isBayerCaddy","true"); //temp
      this.checkAuthAs();
    }

    // searchTerm$ = this.store.pipe(
    //     select(i => i.application.searchTerm)
    // );

    // search(searchTerm: string) {

    //     this.store.dispatch(ContactSearchAction({searchTerm}));
    //     this.router.navigateByUrl('/contact');
    // }

    logout() {
        localStorage.clear();
        this.authService.logout();
    }

    logOutAs() {
      this.authAsUserService.logoutAsUser().subscribe(()=>{
        this.authService.refreshToken().then(()=>{
          this.checkAuthAs();
          this.router.navigateByUrl('/buyer-home').then(() => {
            window.location.reload();
          });
        });
      })
    }

    async checkAuthAs(){
     await this.authService.checkAuthAs();
    }


}
